import e, { extractVueListeners as t } from "./common/utils/index.js";
import { t as n } from "./_plugin-vue_export-helper-BTgDAbhb.js";
import { ICON_SIZE_MODIFIERS as r } from "./lib/icon/icon-constants.js";
import { NOTICE_KINDS as i } from "./lib/notice/notice-constants.js";
import a from "./lib/notice/notice-icon.js";
import o from "./lib/notice/notice-content.js";
import s from "./lib/notice/notice-action.js";
import { TOAST_ALTERNATE_KINDS as c, TOAST_LAYOUTS as l, TOAST_MIN_DURATION as u, TOAST_ROLES as d } from "./lib/toast/toast-constants.js";
import { createBlock as f, createCommentVNode as p, createElementBlock as m, createElementVNode as h, createTextVNode as g, createVNode as _, mergeProps as v, normalizeClass as y, openBlock as b, renderSlot as x, resolveComponent as S, resolveDynamicComponent as C, toDisplayString as w, withCtx as T } from "vue";
import { DtIconAlertTriangle as E, DtIconBell as D, DtIconInfo as O, DtIconSparkle as k } from "@dialpad/dialtone-icons/vue";
//#region components/toast/layouts/toast_layout_default.vue
var A = {
	name: "ToastLayoutDefault",
	components: {
		DtNoticeIcon: a,
		DtNoticeContent: o,
		DtNoticeAction: s
	},
	inheritAttrs: !1,
	props: {
		isShown: {
			type: Boolean,
			default: !1
		},
		headerId: {
			type: String,
			default() {
				return e.getUniqueString();
			}
		},
		contentId: {
			type: String,
			default() {
				return e.getUniqueString();
			}
		},
		headerText: {
			type: String,
			default: void 0
		},
		message: {
			type: String,
			default: ""
		},
		role: {
			type: String,
			default: "status",
			validator: (e) => d.includes(e)
		},
		kind: {
			type: String,
			default: "base",
			validator: (e) => i.includes(e)
		},
		important: {
			type: Boolean,
			default: !1
		},
		showClose: {
			type: Boolean,
			default: !0
		},
		showIcon: {
			type: Boolean,
			default: !0
		},
		showAction: {
			type: Boolean,
			default: !0
		},
		iconClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		headerClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		contentClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		actionClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		}
	},
	emits: ["close"],
	computed: {
		kindClass() {
			return {
				critical: "d-toast--critical",
				info: "d-toast--info",
				positive: "d-toast--positive",
				warning: "d-toast--warning",
				base: "d-toast--base"
			}[this.kind];
		},
		toastListeners() {
			return t(this.$attrs);
		}
	}
}, j = ["aria-hidden"], M = { class: "d-toast__dialog" };
function N(e, t, n, r, i, a) {
	let o = S("dt-notice-icon"), s = S("dt-notice-content"), c = S("dt-notice-action");
	return n.isShown ? (b(), m("div", {
		key: 0,
		class: y([
			"d-toast",
			a.kindClass,
			e.$attrs.class,
			{ "d-toast--important": n.important }
		]),
		"data-qa": "dt-toast",
		"aria-hidden": (!n.isShown).toString()
	}, [h("div", M, [
		n.showIcon ? (b(), f(o, v({
			key: 0,
			kind: n.kind,
			"icon-class": n.iconClass,
			class: { "d-notice__icon--has-title": n.headerText || e.$slots.header }
		}, a.toastListeners), {
			default: T(() => [x(e.$slots, "icon")]),
			_: 3
		}, 16, [
			"kind",
			"icon-class",
			"class"
		])) : p("", !0),
		_(s, v({
			"header-id": n.headerId,
			"content-id": n.contentId,
			"header-text": n.headerText,
			"header-class": n.headerClass,
			"content-class": n.contentClass,
			role: n.role
		}, a.toastListeners), {
			header: T(() => [x(e.$slots, "header")]),
			default: T(() => [x(e.$slots, "default", {}, () => [g(w(n.message), 1)])]),
			_: 3
		}, 16, [
			"header-id",
			"content-id",
			"header-text",
			"header-class",
			"content-class",
			"role"
		]),
		_(c, v({
			"show-action": n.showAction,
			"show-close": n.showClose,
			"action-class": n.actionClass
		}, a.toastListeners, { onClose: t[0] || (t[0] = (t) => e.$emit("close")) }), {
			default: T(() => [x(e.$slots, "action")]),
			_: 3
		}, 16, [
			"show-action",
			"show-close",
			"action-class"
		])
	])], 10, j)) : p("", !0);
}
var P = /* @__PURE__ */ n(A, [["render", N]]), F = new Map([
	["info", O],
	["positive", O],
	["warning", E],
	["critical", O],
	["base", D],
	["gradient", k]
]), I = {
	compatConfig: { MODE: 3 },
	name: "DtToastLayoutAlternateIcon",
	components: {
		DtIconInfo: O,
		DtIconAlertTriangle: E,
		DtIconBell: D,
		DtIconSparkle: k
	},
	props: {
		kind: {
			type: String,
			default: "base",
			validator(e) {
				return c.includes(e);
			}
		},
		size: {
			type: String,
			default: "400",
			validator: (e) => Object.keys(r).includes(e)
		},
		iconClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		}
	},
	computed: { defaultIcon() {
		return F.get(this.kind);
	} }
};
function L(e, t, n, r, i, a) {
	return b(), m("div", {
		"aria-hidden": "true",
		class: y(["d-toast-layout-alternate__icon", n.iconClass])
	}, [x(e.$slots, "default", {}, () => [a.defaultIcon ? (b(), f(C(a.defaultIcon), {
		key: 0,
		size: n.size
	}, null, 8, ["size"])) : p("", !0)])], 2);
}
//#endregion
//#region components/toast/layouts/toast_layout_alternate.vue
var R = {
	name: "ToastLayoutAlternate",
	components: {
		DtNoticeAction: s,
		DtNoticeContent: o,
		DtToastLayoutAlternateIcon: /* @__PURE__ */ n(I, [["render", L]])
	},
	inheritAttrs: !1,
	props: {
		isShown: {
			type: Boolean,
			default: !1
		},
		headerId: {
			type: String,
			default() {
				return e.getUniqueString();
			}
		},
		contentId: {
			type: String,
			default() {
				return e.getUniqueString();
			}
		},
		headerText: {
			type: String,
			default: void 0
		},
		message: {
			type: String,
			default: ""
		},
		role: {
			type: String,
			default: "status",
			validator: (e) => d.includes(e)
		},
		kind: {
			type: String,
			default: "base",
			validator: (e) => c.includes(e)
		},
		showClose: {
			type: Boolean,
			default: !0
		},
		showIcon: {
			type: Boolean,
			default: !0
		},
		iconClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		headerClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		contentClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		actionClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		}
	},
	computed: {
		kindClass() {
			return {
				critical: "d-toast-alternate--critical",
				info: "d-toast-alternate--info",
				positive: "d-toast-alternate--positive",
				warning: "d-toast-alternate--warning",
				gradient: "d-toast-alternate--gradient"
			}[this.kind];
		},
		toastListeners() {
			return t(this.$attrs);
		}
	}
}, z = ["aria-hidden"], B = { class: "d-toast-alternate__dialog" }, V = { class: "d-toast-alternate__header" }, H = { class: "d-toast-alternate__content" };
function U(e, t, n, r, i, a) {
	let o = S("dt-toast-layout-alternate-icon"), s = S("dt-notice-content"), c = S("dt-notice-action");
	return n.isShown ? (b(), m("div", {
		key: 0,
		class: y([
			"d-toast-alternate",
			e.$attrs.class,
			a.kindClass
		]),
		"data-qa": "dt-toast",
		"aria-hidden": (!n.isShown).toString()
	}, [h("div", B, [h("div", V, [
		n.showIcon ? (b(), f(o, v({
			key: 0,
			kind: n.kind,
			"icon-class": n.iconClass,
			size: "200"
		}, a.toastListeners), {
			default: T(() => [x(e.$slots, "icon")]),
			_: 3
		}, 16, ["kind", "icon-class"])) : p("", !0),
		_(s, v({
			"header-id": n.headerId,
			"content-id": n.contentId,
			"header-text": n.headerText,
			"header-class": n.headerClass,
			"content-class": n.contentClass,
			role: n.role
		}, a.toastListeners), {
			header: T(() => [x(e.$slots, "header")]),
			_: 3
		}, 16, [
			"header-id",
			"content-id",
			"header-text",
			"header-class",
			"content-class",
			"role"
		]),
		_(c, v({
			"show-action": !1,
			"show-close": n.showClose,
			"action-class": n.actionClass,
			"button-size": 100
		}, a.toastListeners, { onClose: t[0] || (t[0] = (t) => e.$emit("close")) }), null, 16, ["show-close", "action-class"])
	]), h("div", H, [x(e.$slots, "default", {}, () => [g(w(n.message), 1)])])])], 10, z)) : p("", !0);
}
var W = /* @__PURE__ */ n(R, [["render", U]]), G = {
	compatConfig: { MODE: 3 },
	name: "DtToast",
	components: {
		ToastLayoutDefault: P,
		ToastLayoutAlternate: W
	},
	inheritAttrs: !1,
	props: {
		headerId: {
			type: String,
			default: void 0
		},
		contentId: {
			type: String,
			default: void 0
		},
		headerText: {
			type: String,
			default: void 0
		},
		message: {
			type: String,
			default: void 0
		},
		role: {
			type: String,
			default: "status"
		},
		kind: {
			type: String,
			default: void 0
		},
		important: {
			type: Boolean,
			default: !1
		},
		open: {
			type: Boolean,
			default: !1
		},
		showClose: {
			type: Boolean,
			default: !0
		},
		showIcon: {
			type: Boolean,
			default: !0
		},
		showAction: {
			type: Boolean,
			default: !0
		},
		duration: {
			type: Number,
			default: null,
			validator: (e) => e >= u
		},
		layout: {
			type: String,
			default: "default",
			validator: (e) => l.includes(e)
		},
		iconClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		headerClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		contentClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		actionClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		}
	},
	emits: ["close", "update:open"],
	data() {
		return {
			isShown: !1,
			minDuration: u
		};
	},
	computed: {
		shouldSetTimeout() {
			return !!this.duration && this.duration >= this.minDuration;
		},
		selectedLayout() {
			return this.layout === "alternate" ? W : P;
		}
	},
	watch: { open: {
		handler: function(e) {
			this.isShown = e, e ? this.setTimeout() : clearTimeout(this.displayTimer);
		},
		immediate: !0
	} },
	unmounted() {
		clearTimeout(this.displayTimer);
	},
	methods: {
		setTimeout() {
			this.shouldSetTimeout && (this.displayTimer = setTimeout(() => {
				this.isShown = !1, this.$emit("update:open", !1);
			}, this.duration));
		},
		handleClose() {
			this.isShown = !1, this.$emit("close"), this.$emit("update:open", !1);
		}
	}
};
function K(e, t, n, r, i, a) {
	return b(), f(C(a.selectedLayout), v({
		"is-shown": i.isShown,
		"header-id": n.headerId,
		"content-id": n.contentId,
		"header-text": n.headerText,
		message: n.message,
		role: n.role,
		kind: n.kind,
		important: n.important,
		"show-close": n.showClose,
		"show-icon": n.showIcon,
		"show-action": n.showAction,
		"icon-class": n.iconClass,
		"header-class": n.headerClass,
		"content-class": n.contentClass,
		"action-class": n.actionClass
	}, e.$attrs, { onClose: a.handleClose }), {
		icon: T(() => [x(e.$slots, "icon")]),
		header: T(() => [x(e.$slots, "header")]),
		action: T(() => [x(e.$slots, "action")]),
		default: T(() => [x(e.$slots, "default", {}, () => [g(w(n.message), 1)])]),
		_: 3
	}, 16, [
		"is-shown",
		"header-id",
		"content-id",
		"header-text",
		"message",
		"role",
		"kind",
		"important",
		"show-close",
		"show-icon",
		"show-action",
		"icon-class",
		"header-class",
		"content-class",
		"action-class",
		"onClose"
	]);
}
var q = /* @__PURE__ */ n(G, [["render", K]]);
//#endregion
export { q as t };

//# sourceMappingURL=toast-DqbTiHVx.js.map